import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ButtonProps } from '@mui/material'
import { Button, css, styled, Typography } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import type { To } from 'react-router'

import { COLORS, ICONS, LinkUnstyled, unit } from '@hcr/ui'

type LinkProps = PropsWithChildren &
  ButtonProps & {
    disableBorderBottom?: boolean
    icon?: IconDefinition | undefined
    rel?: string | undefined
    target?: string | undefined
    title: string
    to?: To | string
  }

export const Link: FC<LinkProps> = ({
  icon = ICONS.farChevronRight,
  children,
  title,
  to,
  rel,
  target,
  disableBorderBottom = false,
  ...rest
}) => {
  return (
    <LinkWrapper
      {...rest}
      component={LinkUnstyled as React.ElementType}
      to={to}
      target={target}
      rel={rel}
      $disableBorderBottom={disableBorderBottom}
    >
      <Typography variant='labelM'>{title}</Typography>
      <FontAwesomeIcon fontSize={unit(5)} aria-hidden={true} icon={icon} />
      {children}
    </LinkWrapper>
  )
}

const LinkWrapper = styled(Button)<{ $disableBorderBottom?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: ${unit(4)} ${unit(7)};
  color: ${COLORS.black};

  ${props =>
    !props.$disableBorderBottom &&
    css`
      border-bottom: ${unit(0.25)} solid ${COLORS.vaalea[600]};
    `}
` as typeof Button
